import { SvgIcon, SvgIconProps } from "@mui/material";

export const Plus = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 448 512" {...props}>
      <path fill={props.htmlColor || "#1d1d1f"} d="" />

      <path opacity={0.2}   fill={props.htmlColor || "#1d1d1f"} d="" />
      <path
         fill={props.htmlColor || "#1d1d1f"}
        d="M248 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0 0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0 0-176z"
      />
    </SvgIcon>
  );
};
